import PropTypes from "prop-types";
import { createContext, useEffect } from "react";
import useLocalStorage from "../hooks/useLocalStorage";
import { defaultSettings } from "../config";
import useLocales from "../hooks/useLocales";
import { LOCAL_STORAGE_TOKENS } from "../utils/constants";

// ----------------------------------------------------------------------

const initialState = {
  ...defaultSettings,
  setSettings: () => {},
};

const SettingsContext = createContext(initialState);

// ----------------------------------------------------------------------

SettingsProvider.propTypes = {
  children: PropTypes.node,
};
const { localKey_settings } = LOCAL_STORAGE_TOKENS;
function SettingsProvider({ children }) {
  const { onChangeLang } = useLocales();
  const [settings, setSettings] = useLocalStorage(localKey_settings, {
    theme: initialState.theme,
    language: initialState.language,
  });

  useEffect(() => {
    onChangeLang(settings.language);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [settings.language]);

  return (
    <SettingsContext.Provider
      value={{
        ...settings,
        setSettings,
      }}
    >
      {children}
    </SettingsContext.Provider>
  );
}

export { SettingsProvider, SettingsContext };
